import { Bot, GraduationCap, Heart, Sparkles } from 'lucide-react'
import './AgentSwitcher.css'

export type AgentMode = 'general' | 'twin' | 'expert' | 'askai'

interface Props {
  mode: AgentMode
  onChange: (mode: AgentMode) => void
  experts?: Array<{ id: string; name: string }>
  activeExpertId?: string
  onPickExpert?: (id: string) => void
}

const MODE_META: Record<AgentMode, { label: string; icon: React.ComponentType<any> }> = {
  general: { label: 'AI',     icon: Bot },
  twin:    { label: 'Twin',   icon: Heart },
  expert:  { label: 'Expert', icon: GraduationCap },
  askai:   { label: 'Ask AI', icon: Sparkles },
}

export function AgentSwitcher({ mode, onChange, experts = [], activeExpertId, onPickExpert }: Props) {
  return (
    <div className="runai-agent-switcher">
      {(Object.keys(MODE_META) as AgentMode[]).map(m => {
        const M = MODE_META[m]
        const Icon = M.icon
        return (
          <button
            key={m}
            className={`runai-agent-chip ${mode === m ? 'is-active' : ''}`}
            onClick={() => onChange(m)}
            type="button"
          >
            <Icon size={12} />
            <span>{M.label}</span>
          </button>
        )
      })}
      {mode === 'expert' && experts.length > 0 && (
        <select
          className="runai-agent-expert-select"
          value={activeExpertId || ''}
          onChange={e => onPickExpert?.(e.target.value)}
        >
          <option value="">Pick expert…</option>
          {experts.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        </select>
      )}
    </div>
  )
}
